import React from 'react'
import {
  Box,
  IconButton,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { autonomyColor } from '../../global-styles/autonomyColor'
import { useCustomerContext } from './CustomerContext'
import DeleteDialog from 'shared/DeleteDialog'
import { formattedPhoneNumber } from './useCustomers.utils'
import BorderColorIcon from '@mui/icons-material/BorderColor'
import Delete from '@mui/icons-material/Delete'
import { FormDrawerComponent } from 'shared/FormDrawerComponent'
import useCustomerInfo from './useCustomerInfo'
import { EditCustomerAddress } from './EditCustomerAddress'
import { useTheme } from '../../utils/themeContext'
import { getColorsForTheme } from '../../global-styles/clientColors'
import {RelatedAccounts} from './RelatedAccounts/RelatedAccounts'
import { ReturnVehicleButton } from './ReturnVehicle/ReturnVehicleButton'

export const CustomerInfo = () => {
  const { customerInfo, subscriptionStatus, vehicleId } = useCustomerContext()
  const {
    handleCloseFakePhone,
    onUpdateFakePhone,
    isUpdateAddOpen,
    onToggleUpdateAddress,
    onHandleUpdateAddress,
    getDefaultValues,
    phoneNumber,
  } = useCustomerInfo()

  const { currentTheme } = useTheme()
  const themeColors = getColorsForTheme(currentTheme)

  return (
    <>
      <Table size={'small'}>
        <TableHead>
          <TableRow>
            <TableCell>
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <Box sx={{ ml: 1 }}>
                  <Link
                    color={themeColors.buttonColor}
                    variant="subtitle2"
                    sx={{
                      '&:hover': {
                        color: themeColors.buttonHover,
                      },
                    }}
                  >
                    Basic Details
                  </Link>
                </Box>
              </Box>
            </TableCell>
            <TableCell>
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <Box sx={{ ml: 1 }}>
                  <Link color="inherit" variant="subtitle2"></Link>
                </Box>
              </Box>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow hover>
            <TableCell>
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <Box sx={{ ml: 1 }}>
                  <Link
                    color={autonomyColor.white}
                    variant="subtitle2"
                    sx={{
                      color: autonomyColor.white,
                      '&:hover': {
                        color: themeColors.buttonHover,
                      },
                    }}
                  >
                    Email
                  </Link>
                </Box>
              </Box>
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>
              {customerInfo?.email}
            </TableCell>
          </TableRow>
          <TableRow hover>
            <TableCell>
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <Box sx={{ ml: 1 }}>
                  <Link
                    color={autonomyColor.white}
                    variant="subtitle2"
                    sx={{
                      color: autonomyColor.white,
                      '&:hover': {
                        color: themeColors.buttonHover,
                      },
                    }}
                  >
                    Phone
                  </Link>
                </Box>
              </Box>
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>
              {customerInfo?.phone
                ? formattedPhoneNumber(customerInfo?.phone)
                : null}
              {customerInfo?.phone ? (
                <span>
                  <Tooltip title="Replace with fake phone number">
                    <IconButton
                      className="xsIcon"
                      onClick={() => {
                        handleCloseFakePhone(customerInfo?.phone)
                      }}
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                </span>
              ) : null}
            </TableCell>
          </TableRow>
          <TableRow hover>
            <TableCell>
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <Box sx={{ ml: 1 }}>
                  <Link
                    color={autonomyColor.white}
                    variant="subtitle2"
                    sx={{
                      color: autonomyColor.white,
                      '&:hover': {
                        color: themeColors.buttonHover,
                      },
                    }}
                  >
                    Parking Address
                  </Link>
                </Box>
              </Box>
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>
              {customerInfo?.parkingAddress}{' '}
              <Tooltip title="Edit Parking Address">
                <IconButton
                  className="xsIcon"
                  onClick={() => onToggleUpdateAddress('Parking Address')}
                  disabled={!customerInfo?.parkingAddress}
                >
                  <BorderColorIcon />
                </IconButton>
              </Tooltip>
            </TableCell>
          </TableRow>
          <TableRow hover>
            <TableCell>
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <Box sx={{ ml: 1 }}>
                  <Link
                    color={autonomyColor.white}
                    variant="subtitle2"
                    sx={{
                      color: autonomyColor.white,
                      '&:hover': {
                        color: themeColors.buttonHover,
                      },
                    }}
                  >
                    License Address
                  </Link>
                </Box>
              </Box>
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>
              {customerInfo?.licenseAddress}{' '}
              <Tooltip title="Edit License Address">
                <IconButton
                  className="xsIcon"
                  onClick={() => onToggleUpdateAddress('License Address')}
                  disabled={!customerInfo?.licenseAddress}
                >
                  <BorderColorIcon />
                </IconButton>
              </Tooltip>
            </TableCell>
          </TableRow>
          <TableRow hover>
            <TableCell>
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <Box sx={{ ml: 1 }}>
                  <Link
                    color={autonomyColor.white}
                    variant="subtitle2"
                    sx={{
                      color: autonomyColor.white,
                      '&:hover': {
                        color: themeColors.buttonHover,
                      },
                    }}
                  >
                    Contact Address
                  </Link>
                </Box>
              </Box>
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>
              {customerInfo?.contactAddress}{' '}
              <Tooltip title="Edit Contact Address">
                <IconButton
                  className="xsIcon"
                  onClick={() => onToggleUpdateAddress('Contact Address')}
                  disabled={!customerInfo?.licenseAddress}
                >
                  <BorderColorIcon />
                </IconButton>
              </Tooltip>
            </TableCell>
          </TableRow>
          <TableRow hover>
            <TableCell>
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <Box sx={{ ml: 1 }}>
                  <Link
                    color={autonomyColor.white}
                    variant="subtitle2"
                    sx={{
                      color: autonomyColor.white,
                      '&:hover': {
                        color: themeColors.buttonHover,
                      },
                    }}
                  >
                    Subscription status
                  </Link>
                </Box>
              </Box>
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>
              {subscriptionStatus}
            </TableCell>
          </TableRow>
          <TableRow hover>
            <TableCell>
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <Box sx={{ ml: 1 }}>
                  <Link
                    color={autonomyColor.white}
                    variant="subtitle2"
                    sx={{
                      color: autonomyColor.white,
                      '&:hover': {
                        color: themeColors.buttonHover,
                      },
                    }}
                  >
                    Account Number
                  </Link>
                </Box>
              </Box>
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>
              {customerInfo?.accountNumber}
            </TableCell>
          </TableRow>
          <TableRow hover>
            <TableCell>
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <Box sx={{ ml: 1 }}>
                  <Link
                    color={autonomyColor.white}
                    variant="subtitle2"
                    sx={{
                      color: autonomyColor.white,
                      '&:hover': {
                        color: themeColors.buttonHover,
                      },
                    }}
                  >
                    Driver&apos;s License Exp. Date
                  </Link>
                </Box>
              </Box>
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>
              {customerInfo?.licenseExpirationDate}
            </TableCell>
          </TableRow>
          <TableRow hover>
            <TableCell>
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <Box sx={{ ml: 1 }}>
                  <Link
                    color={autonomyColor.white}
                    variant="subtitle2"
                    sx={{
                      color: autonomyColor.white,
                      '&:hover': {
                        color: themeColors.buttonHover,
                      },
                    }}
                  >
                    Vehicle ID
                  </Link>
                </Box>
              </Box>
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                {vehicleId ? (
                  <Link
                    component={RouterLink}
                    to={`/view/listings/${vehicleId}`}
                    color={themeColors.buttonColor}
                    sx={{
                      '&:hover': {
                        color: themeColors.buttonHover,
                      },
                    }}
                  >
                    {vehicleId}
                  </Link>
                ) : (
                  <span>-</span>
                )}
                {subscriptionStatus === 'ACTIVE' && vehicleId && (
                  <ReturnVehicleButton />
                )}
              </Box>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <RelatedAccounts />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <DeleteDialog
        open={Boolean(phoneNumber)}
        handleClose={() => handleCloseFakePhone(null)}
        title="Update customer with fake phone number"
        description={`You are about to change the phone number ${customerInfo?.phone} to a fake number would you like to proceed?`}
        onConfirm={onUpdateFakePhone}
      />

      {isUpdateAddOpen && (
        <FormDrawerComponent
          isDrawerOpen={
            typeof isUpdateAddOpen === 'string' ? true : isUpdateAddOpen
          }
          setIsDrawerOpen={onToggleUpdateAddress}
          header={`Edit ${isUpdateAddOpen}`}
          handleSave={onHandleUpdateAddress}
          defaultValues={getDefaultValues()}
          form={({ errors, control }) => {
            return <EditCustomerAddress errors={errors} control={control} />
          }}
        />
      )}
    </>
  )
}
